export default {
    url: 'https://scusesoapp01prd.bunzlusa.com/api/v1',
   //url: 'https://corpquinnox.bunzlusa.com/api/v1',
    isR3App: false
}